import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=282cd47e&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=ts"
export * from "./alerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cd47e",
  null
  
)

export default component.exports